<template>
   <div>
      <span> <b-icon icon="eye"></b-icon>&nbsp; {{ streamStatistic.view_count }} </span>

      <span class="ml-4">
         <b-icon icon="heart"></b-icon>
         &nbsp; {{ getAllLikeCount }}
      </span>
   </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
   name: "ViewLikeCount",
   computed: {
      ...mapGetters(["getAllLikeCount", "streamStatistic"])
   }
};
</script>
